export default "__VITE_ASSET__DhABe3rY__"